import { Link } from "react-router-dom";
import Typography from "../../../../../../components/typography/Typography";
import { PAGE_PATH } from "../../../../../../path";
import YaraMatchesMoreRulesTooltip from "./YaraMatchesMoreRulesTooltip";
import { YaraRuleMatch } from "../../../../@types";
import styles from "./yara-matches.module.scss";

type YaraMatchesMatchedRulesProps = {
  rules: Array<YaraRuleMatch>;
  matchedRulesetId?: number;
  threshold?: number;
};

const YaraMatchesMatchedRules = ({
  rules,
  matchedRulesetId,
  threshold = 50
}: YaraMatchesMatchedRulesProps) => {
  const getYaraMatchedRulesetLink = (ruleName: string) =>
    matchedRulesetId
      ? `${PAGE_PATH.YARA}${PAGE_PATH.YARA_DETAILS.replace(
          ":rulesetId",
          matchedRulesetId.toString()
        )}?filterRule=${encodeURIComponent(ruleName)}`
      : undefined;
  const ruleNames = rules.map(rule => rule.name);

  if (ruleNames.length === 0) {
    return null;
  }

  const rulesThatFit: string[] = [];
  const rulesToPutInTooltip: string[] = [];
  let currentRulesLength = 0;
  ruleNames.forEach(ruleName => {
    if (currentRulesLength + ruleName.length > threshold) {
      rulesToPutInTooltip.push(ruleName);
      return;
    }
    currentRulesLength += ruleName.length;
    rulesThatFit.push(ruleName);
  });

  if (rulesThatFit.length === 0 && ruleNames.length > 0) {
    const firstRuleLink = getYaraMatchedRulesetLink(ruleNames[0]);
    return (
      <div className={"flex"}>
        {firstRuleLink ? (
          <Link
            to={firstRuleLink}
            className={styles.item_link}
            title={ruleNames[0]}
          >
            {ruleNames[0].slice(0, threshold - 3)}...
          </Link>
        ) : (
          ruleNames[0].slice(0, threshold - 3)
        )}
        <YaraMatchesMoreRulesTooltip rules={ruleNames.slice(1)} />
      </div>
    );
  }

  return (
    <div className={"flex flex-gap-1"}>
      <Typography variant={"body1"}>
        {rulesThatFit.map((ruleName, index) => {
          const ruleLink = getYaraMatchedRulesetLink(ruleName);
          return (
            <span key={ruleName}>
              {ruleLink ? (
                <Link to={ruleLink} className={styles.item_link}>
                  {ruleName}
                </Link>
              ) : (
                ruleName
              )}
              {index < rulesThatFit.length - 1 && ", "}
            </span>
          );
        })}
      </Typography>
      <YaraMatchesMoreRulesTooltip rules={rulesToPutInTooltip} />
    </div>
  );
};

export default YaraMatchesMatchedRules;
